import { BooleanStore, AnyStore } from 'stores';

import { ControlsStoreType, ContentStoreType } from '../types';

const modalStore = new BooleanStore();
const controlsStore = new AnyStore<ControlsStoreType>({});
const contentStore = new AnyStore<ContentStoreType | any>({ title: '', body: '' });

export { modalStore, controlsStore, contentStore };
